export var ButtonLabelVisibility;
(function (ButtonLabelVisibility) {
    ButtonLabelVisibility["Default"] = "default";
    ButtonLabelVisibility["S"] = "s";
    ButtonLabelVisibility["M"] = "m";
    ButtonLabelVisibility["L"] = "l";
    ButtonLabelVisibility["XL"] = "xl";
})(ButtonLabelVisibility || (ButtonLabelVisibility = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Default"] = "default";
    ButtonSize["Icon"] = "icon";
    ButtonSize["IconStretched"] = "icon-stretched";
})(ButtonSize || (ButtonSize = {}));
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["Default"] = "default";
    ButtonVariant["Primary"] = "primary";
    ButtonVariant["NoBorder"] = "no-border";
})(ButtonVariant || (ButtonVariant = {}));
//# sourceMappingURL=button.enum.js.map
